import { Outlet } from "react-router-dom";

export const catalogConfigs = {
  title: {
    default: "Shinsung",
    ko: "전자카탈로그 템플릿",
  },
  langSet: ["en"],
  pageMap: [
    { name: "cover" },
    { name: "catalog-index" },
    {
      name: "company",
      outlets: [
        {
          name: "about",
          outlets: [
            "about-main",
            {
              name: "about-contents",
              outlets: ["overview", "solution", "production", "research", "partners"],
            },
          ],
        },
        {
          name: "history",
        },
        {
          name: "oem",
          outlets: ["overview", "process", "builder"],
        },
      ],
    },
    { name: "lineup" },
    {
      name: "products",
      outlets: [
        {
          name: "cooking",
          outlets: [
            "cooking-main",
            {
              name: "cooking-contents",
              outlets: [
                "cooking-tools",
                "cutting-board",
                "food-container",
                "food-molds",
                "cutlery",
                "table-ware",
              ],
            },
          ],
        },
        {
          name: "baby",
          outlets: [
            "baby-main",
            {
              name: "baby-contents",
              outlets: [
                "food-supplies",
                "cutlery",
                "brush-nipple-bottle",
                "brush-nipple-bottle-2",
                "bib-teether",
              ],
            },
          ],
        },
        {
          name: "living",
          outlets: [
            "living-main",
            {
              name: "living-contents",
              outlets: ["bathroom", "beauty"],
            },
          ],
        },
      ],
    },
    {
      name: "show-room",
      outlets: [
        "main",
        {
          name: "content",
          outlets: ["tools", "silicone", "bib"],
        },
      ],
    },
    { name: "last" },
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 768,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
